import { modifier } from 'ember-modifier';

export default modifier(function resizeListener(element, [callback]) {
  if (typeof callback !== 'function') {
    return;
  }

  const handleResize = () => callback(element);

  window.addEventListener('resize', handleResize);

  return () => {
    window.removeEventListener('resize', handleResize);
  };
});
